import owd from 'owd/owd';
import browser from 'owd/utils/browser';

export default class Fix100vh extends owd.Component {
	init() {
		this.$refs = $('[data-fix-100vh-ref]');

		this.bind();
		this.calc();
	}

	calc() {
		if (window.matchMedia('(max-width:1024px)').matches) {
			let vh = this.app.dom.$window.height();
			let refsHeight = 0;

			this.$refs.each((i, obj) => {
				refsHeight += $(obj).outerHeight();
			});

			this.$element.css('height', (vh - refsHeight) + 'px').addClass('fix-100vh-applied');
		} else {
			this.$element.filter('.fix-100vh-applied').css('height', '').removeClass('fix-100vh-applied');
		}
	}

	bind() {
		this.on('load resize', this.dom.$window, () => {
			this.calc();
		})
	}

	destroy() {
		super.destroy();
	}
}

owd.registerComponent('fix-100vh', {
	component: Fix100vh
});
